import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, } from "react";
export var AttributeStrategyType;
(function (AttributeStrategyType) {
    AttributeStrategyType["Simple"] = "Simple";
    // ViewLevel = "ViewLevel", // maybe later
    AttributeStrategyType["Layout"] = "Layout";
})(AttributeStrategyType || (AttributeStrategyType = {}));
const AttributeStrategyContext = createContext({
    strategy: AttributeStrategyType.Layout,
    setStrategy() {
        // nothing
    },
});
AttributeStrategyContext.displayName = "AttributeStrategyContext";
export function AttributeStrategyProvider({ defaultStrategy, children, }) {
    const [strategy, setStrategy] = useState(defaultStrategy);
    return (_jsx(AttributeStrategyContext.Provider, { value: { strategy, setStrategy }, children: children }));
}
export function useAttributeStrategy() {
    return useContext(AttributeStrategyContext);
}
//# sourceMappingURL=AttributeStrategyProvider.js.map